<script>
import vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      required: false
    }
  },
  data() {
    return {};
  },
  methods: {},
  // mounted() {
  //   console.log("isModalOpen ", this.$props.isModalOpen);
  // },
};
</script>

<template>
  <div>
    <transition name="body">
      <div v-if="isModalOpen" class="modal__wrapper">
        <div :style="width ? `width: ${width}px` : ''" class="modal__box" v-click-outside="() => $emit('close')">
          <button class="close__button" @click="$emit('close')">
            <svg>
              <use xlink:href="@/assets/icons/close.svg#close"></use>
            </svg>
          </button>
          <slot name="body"></slot>
        </div>
      </div>
    </transition>

    <transition name="backdrop">
      <div v-if="isModalOpen" class="modal__backdrop"></div>
    </transition>
  </div>
</template>

<style scoped lang="scss">
.modal__backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 997;
  transform-origin: center;
  pointer-events: none;
}

.modal__wrapper {
  top: 0;
  left: 0;
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 998;
}

.modal__box {
  position: relative;
  padding: 32px;
  border: 1px solid #d1d1d6;
  background-color: #f8f9fa;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999;
  transform-origin: center;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;

  @media screen and (max-width: 1024px) {
    min-width: 60vw;
    max-width: 90vw;
    max-height: 90vh;
    padding: 16px;
  }

  @media screen and (min-width: 1025px) {
    min-width: 350px;
    max-height: 600px;
  }
}

.close__button {
  position: absolute;
  top: 16px;
  right: 16px;
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 50%;
  fill: #637381;
  transition: all ease-in-out 300ms;
  z-index: 999;

  &:hover {
    fill: #3056d3;
    background-color: #edf2ff;
  }

  & > svg {
    width: 20px;
    height: 20px;
    fill: inherit;
  }
}

.backdrop-enter-active,
.backdrop-leave-active {
  transition: all 0.3s ease-in-out;
  opacity: 1;
  transform-origin: center;
}

.backdrop-enter,
.backdrop-leave-to {
  opacity: 0;
}

.body-enter-active,
.body-leave-active {
  transition: all 0.4s ease-in-out;
  scale: 1;
  opacity: 1;
}

.body-enter {
  opacity: 0;
  scale: 0.5;
}
.body-leave-to {
  opacity: 0;
  scale: 1.5;
}
</style>
